/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 * Page dashboard translation constants
 *
 * @author Nikolay Sviridov
 * @version 1.34.0
 * @since 1.34.0
 */

import { IFastActionsTranslation } from '@/main/components/FastActions/types/fastActionsTypes';

import { initTranslationFastActionsModals } from './fastActionsModals';
import { initTranslationFastActionsPlate } from './fastActionsPlate';

export const initTranslationFastActions: IFastActionsTranslation = {
    fastActionsPlate: initTranslationFastActionsPlate,
    fastActionsModals: initTranslationFastActionsModals,
};
